import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { loginService } from '@/services/authService';
import { Link, useNavigate } from 'react-router';
import { enqueueSnackbar } from 'notistack';
import { routes } from '@/constants/routes';
import { ArrowBack } from '@mui/icons-material';
import theme from '@/constants/theme';
import useUser from '@/hooks/useUser';
import Input from '@/components/input/Input';
import Button from '@/components/input/Button';

const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const { user } = useUser();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { access_token, refresh_token } = await loginService(email, password);
      await login(access_token, refresh_token);

      if (user?.role === 'ADMIN') {
        return navigate(routes.admin.root);
      }
      navigate('/');
    } catch (error) {
      console.error('Login Error:', error);
      enqueueSnackbar('Credenciales incorrectas.', {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // const handlePress = () => {
  //   navigate("/");
  // };

  return (
    <div style={styles.container}>
      <Link to={routes.welcome} style={styles.homeIcon}>
        <ArrowBack />
      </Link>
      <form style={styles.form} onSubmit={handleLogin}>
        <img src={require('@/assets/images/light-logo.png')} alt="home" style={styles.logo} />
        <Input
          required
          label="Correo"
          placeholder="Escribe tu correo"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          autoCapitalize="none"
          type="email"
        />
        <Input
          required
          label="Contraseña"
          placeholder="Escribe tu contraseña"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          type="password"
        />
        <Button variant="main" loading={loading}>
          {loading ? 'Iniciando sesión' : 'Iniciar sesión'}
        </Button>
      </form>
      <Link style={styles.redirectToRegister} to={routes.register}>
        ¿Aún no tienes una cuenta?
        <span style={styles.register}>Regístrate</span>
      </Link>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    backgroundColor: theme.colors.background.primary,
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    position: 'relative',
    flexDirection: 'column',
    maxWidth: '100%',
  },
  homeIcon: {
    position: 'absolute',
    top: 40,
    left: 24,
    color: theme.colors.text.default,
  },
  background: {
    flex: 1,
    justifyContent: 'center',
    paddingLeft: 32,
    paddingRight: 32,
    position: 'relative',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    gap: 16,
    width: 400,
    maxWidth: '100%',
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#DEE7E7',
    textAlign: 'center',
    marginBottom: '16px',
  },
  input: {
    height: 48,
    borderWidth: 1,
    borderColor: '#DEE7E7',
    borderRadius: 8,
    paddingLeft: 12,
    paddingRight: 12,
    marginBottom: 16,
    color: '#0F1A3D',
    backgroundColor: '#fff',
  },
  button: {
    justifyContent: 'center',
    fontWeight: 'bold',
    marginTop: 26,
  },
  buttonText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 16,
  },
  redirectToRegister: {
    color: theme.colors.text.subtitle,
    textAlign: 'center',
    marginTop: 16,
  },
  register: {
    color: theme.colors.primary,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginInline: '8px',
  },
  logo: {
    width: 320,
    marginInline: 'auto',
    maxWidth: '100%',
    objectPosition: '12px 4px',
    objectFit: 'cover',
  },
};

export default LoginScreen;
